export const page = {
  go_mui_components_dashboard: 'Go to MUI Components Dashboard',
  card: 'Cards',
  typography: 'Typography',
  color: 'Colors',
  button: 'Buttons',
  shadow: 'Shadows',
};
